import {lazy} from "react";

export const ResultsAsync = lazy(() => import('./Results'))
